import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ResultSearchRequest, ResultSearchRow } from '../main/models/result-search';

/**
 * `POST /results/search` returns a plain `Flux<ResultSearchRow>` with no
 * `produces = "application/x-ndjson"` override (unlike the general Search
 * tab's `/search` endpoint), so Spring WebFlux buffers it into one ordinary
 * JSON array response - a plain `HttpClient.post` is enough, no NDJSON
 * incremental parsing needed (contrast `FilesService.search()`).
 */
@Injectable({
  providedIn: 'root',
})
export class ResultSearchService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.slideCropServer;
  }

  private join(path: string): string {
    // environment.slideCropServer can be absolute (https://...) or relative (/api/)
    // Ensure exactly one slash between base and path
    const base = this.url.endsWith('/') ? this.url : `${this.url}/`;
    const p = path.startsWith('/') ? path.substring(1) : path;
    return `${base}${p}`;
  }

  public search(request: ResultSearchRequest): Observable<ResultSearchRow[]> {
    return this.http.post<ResultSearchRow[]>(this.join('results/search'), request);
  }
}
